<template>
  <!-- 员工管理 -->
  <div class="">
    <div v-if="dataInfo.detailCode"
         class="">
      <p class="title">{{ title }}</p>
      <div class="table-box setTable">
        <loading :isShow="listLoading" />
        <Table :columns="columns"
               :data="tableData">
          <template slot-scope="{ row }"
                    slot="receiptRevisitStatus">
            <div>{{ RECEIPT_STATUS[row.receiptStatus] }}/{{ VERIFY_STATUS[row.verifyStatus] }}</div>
          </template>
          <template slot-scope="{ row }"
                    slot="userName">
            <span :class="row.workingState == 1 ? 'opening' : 'close'"></span>{{ row.userName }}
          </template>
          <template slot-scope="{ row }"
                    slot="rateMode">
            <span>{{ row.rateMode == 1 ? '年度' : '月度' }}</span>
            <template v-if="row.calculateIndex == 1">R13</template>
            <template v-else-if="row.calculateIndex == 2">R25 </template>
            <template v-else-if="row.calculateIndex == 3">R37</template>
            <template v-else>R49</template>
          </template>
          <template slot-scope="{ row }"
                    slot="action">
            <span class="table-btn"
                  @click="openDetail(row)">保单明细</span>
          </template>
          <template slot-scope="{ row }"
                    slot="action_1">
            <span class="table-btn"
                  @click="openDetail(row)">详情</span>
          </template>
        </Table>
        <Page :total="total"
              :current.sync="pageNum"
              :page-size="pageSize"
              show-total
              @on-change="getList"
              style="text-align: center" />
      </div>
    </div>

    <!-- 保单详情  -->
    <riseModal ref="riseModalRef"></riseModal>

  </div>
</template>

<script>
  import _ from 'lodash';
  import riseModal from './riseModal';
  import { number_format, filterTime } from '@/api/filter';
  import { pageTool } from '@/api/mixins';
  export default {
    mixins: [pageTool],
    components: {
      riseModal
    },
    data() {
      return {
        title: '',
        dataInfo: {},
        VERIFY_STATUS: {},
        RECEIPT_STATUS: {},
        searchParams: {},
        columns: [],
        columns_1: [
          {
            title: '序号',
            align: 'center',
            width: 80,
            type: 'index'
          },
          {
            title: '姓名',
            minWidth: 80,
            align: 'center',
            key: 'userName'
          },
          {
            title: '工号',
            minWidth: 100,
            align: 'center',
            key: 'staffNo'
          },
          {
            title: '职级',
            minWidth: 100,
            align: 'center',
            key: 'rankName'
          },
          {
            title: '累计出单数',
            minWidth: 100,
            align: 'center',
            key: 'policyNum'
          },
          {
            title: '累计保费（元）',
            minWidth: 100,
            align: 'center',
            key: 'totalFee'
          },
          {
            title: '累计FYC',
            minWidth: 100,
            align: 'center',
            key: 'totalFyc'
          },
          {
            title: '操作',
            minWidth: 100,
            align: 'center',
            slot: 'action',
            fixed: 'right'
          }
        ],
        columns_2: [
          {
            title: '继续率月份',
            key: 'month',
            minWidth: 140,
            align: 'center',
            render(h, params) {
              const row = params.row;
              return (
                <span>
                  {row.year}-{row.month < 10 ? '0' + row.month : row.month}
                </span>
              );
            }
          },
          {
            title: '团队名称',
            minWidth: 140,
            align: 'center',
            key: 'groupName'
          },

          {
            // renderHeader(h, params) {
            //   console.log(params)
            //   if (params.row.owerType == 1) {
            //     return (<span>保险公司</span>)
            //   } else if (params.row.owerType == 2) {
            //     return (<span>通道公司</span>)
            //   } else if (params.row.owerType == 3) {
            //     return (<span>机构名称</span>)
            //   } else if (params.row.owerType == 4) {
            //     return (<span>渠道名称</span>)
            //   }
            // },
            title: '所属机构',
            key: 'owerName',
            minWidth: 140,
            align: 'center'
          },
          {
            title: '团队主管',
            minWidth: 80,
            align: 'center',
            key: 'leaderName'
          },

          {
            title: '是否包含下级机构数据',
            key: 'hasSubOrg',
            minWidth: 160,
            align: 'center',
            render(h, params) {
              const row = params.row;
              return <span>{row.hasSubOrg == 1 ? '是' : '否'}</span>;
            }
          },
          {
            title: '继续率指标',
            slot: 'rateMode',
            minWidth: 140,
            align: 'center'
          },
          {
            title: '继续率',
            key: 'rate',
            minWidth: 140,
            align: 'center',
            render(h, params) {
              const row = params.row;
              return <span>{row.rate}%</span>;
            }
          },
          {
            title: '计算方式',
            key: 'calculateType',
            minWidth: 140,
            align: 'center',
            render(h, params) {
              const row = params.row;
              return <span>{row.calculateType == 1 ? '按承保' : '按实收'}</span>;
            }
          },
          {
            title: '年度R13承保保费（元）',
            minWidth: 200,
            align: 'center',
            key: 'insureFee',
            render(h, params) {
              const row = params.row;
              return <span>{number_format(row.insureFee, 2)}</span>;
            }
          },
          {
            title: '年度R13承保数据范围',
            minWidth: 200,
            align: 'center',
            key: 'insureTimeBegin',
            render(h, params) {
              const row = params.row;
              const date = row.insureTimeBegin.substring(0, 10);
              const endDate = row.insureTimeEnd.substring(0, 10);
              return (
                <span>
                  {date} 至 {endDate}
                </span>
              );
            }
          },
          {
            title: '年度R13实收保费（元）',
            key: 'receiptFee',
            align: 'center',
            minWidth: 180,
            render(h, params) {
              const row = params.row;
              return <span>{number_format(row.receiptFee, 2)}</span>;
            }
          },
          {
            title: '年度R13实收数据范围',
            key: 'receiptTimeBegin',
            align: 'center',
            minWidth: 180,
            render(h, params) {
              const row = params.row;
              const date = row.receiptTimeBegin.substring(0, 10);
              const endDate = row.receiptTimeEnd.substring(0, 10);
              return (
                <span>
                  {date} 至 {endDate}
                </span>
              );
            }
          }
        ],
        columns_3: [
          {
            title: '序号',
            align: 'center',
            width: 80,
            type: 'index'
          },
          {
            title: '姓名',
            minWidth: 100,
            align: 'center',
            key: 'userName'
          },
          {
            title: '工号',
            minWidth: 100,
            align: 'center',
            key: 'staffNo'
          },
          {
            title: '职级',
            minWidth: 100,
            align: 'center',
            key: 'rankName'
          },
          {
            title: '有效人次月份',
            minWidth: 100,
            align: 'center',
            key: 'activeMonth'
          },
          {
            title: '当月保单数',
            minWidth: 100,
            align: 'center',
            key: 'policyNum'
          },
          {
            title: '当月保费（元）',
            minWidth: 100,
            align: 'center',
            key: 'totalFee'
          },
          {
            title: '当月FYC',
            minWidth: 100,
            align: 'center',
            key: 'totalFyc'
          },
          {
            title: '操作',
            minWidth: 100,
            align: 'center',
            slot: 'action',
            fixed: 'right'
          }
        ],
        columns_4: [
          {
            title: '序号',
            align: 'center',
            width: 80,
            type: 'index'
          },
          {
            title: '姓名',
            minWidth: 200,
            align: 'center',
            key: 'userName'
          },
          {
            title: '工号',
            minWidth: 200,
            align: 'center',
            key: 'staffNo'
          },
          {
            title: '职级',
            minWidth: 200,
            align: 'center',
            key: 'rankName'
          }
        ],
        columns_5: [
          {
            title: '序号',
            align: 'center',
            width: 80,
            type: 'index'
          },
          {
            title: '出单人',
            minWidth: 90,
            align: 'center',
            key: 'userName'
          },
          {
            title: '保单号',
            minWidth: 120,
            align: 'center',
            key: 'policyNo'
          },
          {
            title: '保险公司',
            minWidth: 90,
            align: 'center',
            key: 'companyName'
          },
          {
            title: '产品名称',
            minWidth: 120,
            align: 'center',
            key: 'productName'
          },
          {
            title: '险种名称',
            minWidth: 100,
            align: 'center',
            key: 'insuranceName'
          },
          {
            title: '保费（元）',
            minWidth: 90,
            align: 'center',
            key: 'fee'
          },
          {
            title: '实收保费（元）',
            minWidth: 90,
            align: 'center',
            key: 'payFee'
          },
          {
            title: '基础费率',
            minWidth: 90,
            align: 'center',
            key: 'commission',
            render(h, params) {
              return <span>{params.row.commission ? params.row.commission + '%':'-'}</span>;
            }
          },
          {
            title: 'FYC',
            minWidth: 90,
            align: 'center',
            key: 'commissionPrice'
          },
          {
            title: '承保时间',
            minWidth: 90,
            align: 'center',
            key: 'insureTime',
            render(h, params) {
              const value = filterTime(params.row.insureTime, 'YYYY-MM-DD');
              return <span>{value}</span>;
            }
          },
          {
            title: '生效时间',
            minWidth: 90,
            align: 'center',
            key: 'startTime',
            render(h, params) {
              const value = filterTime(params.row.startTime, 'YYYY-MM-DD');
              return <span>{value}</span>;
            }
          },
          {
            title: '保单状态',
            minWidth: 90,
            align: 'center',
            key: 'status',
            render(h, params) {
              const status = params.row.status;
              if (status == 1) {
                return <span>已承保</span>;
              } else if (status == -1) {
                return <span>已退保</span>;
              } else if (status == 0) {
                return <span>已终止</span>;
              }
            }
          }
        ],
        columns_6: [
          {
            title: '序号',
            align: 'center',
            width: 80,
            type: 'index'
          },
          {
            title: '费用项',
            align: 'center',
            width: 200,
            key: 'commissionName'
          },
          {
            title: '规则',
            align: 'center',
            minWidth: 290,
            key: 'ruleName'
          },
          {
            title: '收入',
            align: 'center',
            width: 200,
            key: 'amount'
          },
          {
            title: '操作',
            width: 120,
            align: 'center',
            slot: 'action_1',
            fixed: 'right'
          }
        ],
        columns_7: [
          {
            title: '序号',
            align: 'center',
            width: 80,
            type: 'index'
          },
          {
            title: '工号',
            minWidth: 100,
            align: 'center',
            key: 'staffNo'
          },
          {
            title: '姓名',
            minWidth: 80,
            align: 'center',
            key: 'userName'
          },

          {
            title: '状态',
            minWidth: 100,
            align: 'center',
            key: 'workingState',
            render(h, params) {
              const workingState = params.row.workingState;
              const isSus = params.row.isSus;
              if (workingState == 0) {
                return <span>离职</span>;
              } else if (isSus == 1) {
                return <span>停职</span>;
              } else {
                return <span>在职</span>;
              }
            }
          },
          {
            title: '职级',
            minWidth: 100,
            align: 'center',
            key: 'rankName'
          },

          {
            title: '入职时间',
            minWidth: 100,
            align: 'center',
            key: 'entryTime',
            render(h, params) {
              const date = params.row.entryTime && params.row.entryTime.substring(0, 10);
              return <span>{date}</span>;
            }
          },

          {
            title: '所属机构',
            minWidth: 100,
            align: 'center',
            key: 'organizationName'
          },

          {
            title: '所属团队',
            minWidth: 100,
            align: 'center',
            key: 'groupName'
          },
          {
            title: '当月标保',
            minWidth: 100,
            align: 'center',
            key: 'totalFoldFyb'
          },
          {
            title: '操作',
            width: 120,
            align: 'center',
            slot: 'action_1',
            fixed: 'right'
          }
        ],
        columns_8: [
          {
            title: '继续率月份',
            key: 'month',
            minWidth: 140,
            align: 'center',
            render(h, params) {
              const row = params.row;
              return (
                <span>
                  {row.year}-{row.month < 10 ? '0' + row.month : row.month}
                </span>
              );
            }
          },
          {
            title: '姓名',
            minWidth: 140,
            align: 'center',
            key: 'salesManName'
          },
          {
            title: '所属机构',
            key: 'owerName',
            minWidth: 140,
            align: 'center'
          },
          {
            title: '所属团队',
            minWidth: 100,
            align: 'center',
            key: 'groupName'
          },
          {
            title: '继续率指标',
            slot: 'rateMode',
            minWidth: 140,
            align: 'center'
          },
          {
            title: '继续率',
            key: 'rate',
            minWidth: 140,
            align: 'center',
            render(h, params) {
              const row = params.row;
              return <span>{row.rate}%</span>;
            }
          },
          {
            title: '计算方式',
            key: 'calculateType',
            minWidth: 140,
            align: 'center',
            render(h, params) {
              const row = params.row;
              return <span>{row.calculateType == 1 ? '按承保' : '按实收'}</span>;
            }
          },
          {
            title: '年度R13承保保费（元）',
            minWidth: 200,
            align: 'center',
            key: 'insureFee',
            render(h, params) {
              const row = params.row;
              return <span>{number_format(row.insureFee, 2)}</span>;
            }
          },
          {
            title: '年度R13承保数据范围',
            minWidth: 200,
            align: 'center',
            key: 'insureTimeBegin',
            render(h, params) {
              const row = params.row;
              const date = row.insureTimeBegin.substring(0, 10);
              const endDate = row.insureTimeEnd.substring(0, 10);
              return (
                <span>
                  {date} 至 {endDate}
                </span>
              );
            }
          },
          {
            title: '年度R13实收保费（元）',
            key: 'receiptFee',
            align: 'center',
            minWidth: 180,
            render(h, params) {
              const row = params.row;
              return <span>{number_format(row.receiptFee, 2)}</span>;
            }
          },
          {
            title: '年度R13实收数据范围',
            key: 'receiptTimeBegin',
            align: 'center',
            minWidth: 180,
            render(h, params) {
              const row = params.row;
              const date = row.receiptTimeBegin.substring(0, 10);
              const endDate = row.receiptTimeEnd.substring(0, 10);
              return (
                <span>
                  {date} 至 {endDate}
                </span>
              );
            }
          }
        ]
      };
    },
    created() {
      this.RECEIPT_STATUS = JSON.parse(localStorage.dic)['RECEIPT_STATUS'];
      this.VERIFY_STATUS = JSON.parse(localStorage.dic)['VERIFY_STATUS'];
    },
    mounted() {},
    methods: {
      openDetail(item) {
        console.log(item);
        let columns = _.cloneDeep(this.columns_5);
        if (item.detailCode != 'rycDetailQuery') {
          let idx = columns.findIndex(i => i.key == 'payFee');
          if (idx != -1) {
            columns.splice(idx, 1);
          }
        }
        if (this.dataInfo.detailCode == 'personCheckDetailQuery') {
          this.$refs.riseModalRef.open({
            columns,
            params: { salaryDetailId: item.salaryDetailId, detailId: this.searchParams.detailId },
            detailCode: this.dataInfo.detailCode
          });
        } else {
          this.$refs.riseModalRef.open({
            columns,
            params: { userId: item.userId, detailId: this.searchParams.detailId },
            detailCode: this.dataInfo.detailCode
          });
        }
      },
      init(data) {
        this.columns = [];
        console.log(data);
        console.log(' this.$route.query', this.$route.query);
        this.searchParams = {};
        this.dataInfo = data;
        if (data.detailCode == 'groupFycDetailQuery') {
          this.title = '团队考核期内累计FYC明细';
          this.columns = this.columns_1;
        } else if (data.detailCode == 'groupR13DetailQuery') {
          this.title = '团队年度R13明细';
          this.columns = this.columns_2;
        } else if (data.detailCode == 'groupIssueManpowerDetailQuery') {
          this.title = '团队有效人次明细';
          this.searchParams.activeMonth = this.$route.query.accountDate;
          this.columns = this.columns_3;
        } else if (data.detailCode == 'groupActiveManpowerDetailQuery') {
          this.title = '团队在职人力';
          this.columns = this.columns_4;
        } else if (data.detailCode == 'personR13DetailQuery') {
          this.title = '个人年度R13明细';
          this.columns = this.columns_8;
        } else if (data.detailCode == 'personFycDetailQuery') {
          this.title = '个人考核期内累计FYC明细';
          let columns = _.cloneDeep(this.columns_5);
          let idx = columns.findIndex(i => i.key == 'payFee');
          if (idx != -1) {
            columns.splice(idx, 1);
          }
          this.columns = columns;
        } else if (data.detailCode == 'personCheckDetailQuery') {
          this.title = '基本法收入';
          this.columns = this.columns_6;
        } else if (data.detailCode == 'activeManpowerDetailQuery') {
          this.title = '有效在编人数';
          this.columns = this.columns_7;
        }
        // this.searchParams.userId = data.userId;
        this.searchParams.detailId = data.detailId;
        if (data.detailCode) {
          this.initListAjax('/buz/userPromotionRecord/queryDetail');
        }
      }
    }
  };
</script>
<style lang="scss" scoped>
.title {
  color: #666e7b;
  padding-bottom: 10px;
}

.table-box {
  .close,
  .opening {
    display: inline-block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-right: 4px;
  }

  .close {
    background: #e36767;
  }

  .opening {
    background: #35bf3f;
  }
}

/deep/ .input-item {
  width: 30%;
}

.wrapper .content {
  .search-box {
    .label {
      min-width: 80px;
    }
  }
}

.tableBox {
  .disabled {
    color: #999;
    cursor: default;
  }
}

.descLine {
  span {
    margin-right: 30px;
  }
}

/deep/ .ivu-modal-body {
  padding: 16px 30px;
}
</style>
